export * from './siteListWrapper';
export * from './components';
import { ITabList } from '@components/common/navigator-tab';

export const SiteListTab: ITabList[] = [
	{
		key: 1,
		name: 'All Sites',
		pathUrl: '/lms/sites',
		tabIcon: 'icon-user',
	},
	{
		key: 2,
		name: 'Competition Sites',
		pathUrl: '/lms/sites/competition',
		tabIcon: 'icon-user',
	},
	{
		key: 3,
		name: 'Upcoming Sites',
		pathUrl: '/lms/sites/upcoming',
		tabIcon: 'icon-user',
	},
];

export const MyTaskListTab: ITabList[] = [
	{
		key: 1,
		name: 'Conversion Sites',
		pathUrl: '/lms/my-tasklist/conversion',
		tabIcon: 'icon-user',
	},
	{
		key: 2,
		name: 'Pending Leads',
		pathUrl: '/lms/my-tasklist/pending-leads',
		tabIcon: 'icon-user',
	},
	{
		key: 3,
		name: 'Upcoming Sites',
		pathUrl: '/lms/my-tasklist/upcoming',
		tabIcon: 'icon-user',
	},
];
